export default function WarnIcon(props) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
            <g clipPath="url(#a)">
                <path fill="#ef8b22" d="M25.9 5 5 26q-.6.7-.6 1.5V57q0 1 .6 1.6l21 20.7q.7.7 1.5.7H57q1 0 1.6-.7l20.8-20.8q.7-.6.7-1.6V27.4q0-.8-.7-1.5L58.5 5q-.6-.6-1.6-.6H27.4q-.8 0-1.5.6"/>
                <path fill="#53575a" d="M54 78.5H24.5q-1.5 0-2.6-1L1.1 56.6Q0 55.6 0 54V24.5Q0 23 1 22L22 1.1q1-1 2.5-1.1H54q1.6 0 2.6 1l20.9 21q1 1 1 2.5V54q0 1.6-1 2.6L56.6 77.5q-1 1-2.6 1M24 3.1 3 24l-.2.5V54l.2.6 21 20.8q.2.3.5.2H54l.6-.2 20.8-20.8q.3-.3.2-.6V24.5q0-.3-.2-.5L54.6 3.1 54 3H24.5z"/>
                <path fill="#fff" d="M48 58.2c0 7.7-11.6 7.7-11.6 0s11.6-7.8 11.6 0"/>
                <path fill="#fff" d="M37.8 20.4h8.7q1.4.1 1.5 1.4v20.4q-.1 1.3-1.5 1.4h-8.7q-1.3-.1-1.4-1.4V21.8q.1-1.3 1.4-1.4"/>
                <path fill="#53575a" d="M39.3 62.5a7 7 0 0 1-7.3-7.2 7 7 0 0 1 7.3-7.3 7 7 0 0 1 7.2 7.3 7 7 0 0 1-7.2 7.2m0-11.6c-2.2 0-4.4 1.4-4.4 4.4s2.2 4.3 4.4 4.3c2.1 0 4.3-1.3 4.3-4.3s-2.2-4.4-4.3-4.4"/>
                <path fill="#53575a" d="M43.6 42.2H35a3 3 0 0 1-2.9-3V19a3 3 0 0 1 3-2.9h8.6a3 3 0 0 1 3 3v20.3a3 3 0 0 1-3 2.9M35 18.9v20.4h8.7V18.9z"/>
            </g>
            <defs>
                <clipPath id="a">
                    <rect width="80" height="80"/>
                </clipPath>
            </defs>
        </svg>
    )
}
